import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import EmailIcon from "@mui/icons-material/Email";

export const SOCIAL_ITEMS_PROPS = [
  {
    icon: GitHubIcon,
    url: "https://github.com/valvic66",
    onClick: () => { console.log("clicked github option"); },
  },
  {
    icon: LinkedInIcon,
    url: "https://www.linkedin.com/in/valentin-micu-973902148/",
    onClick: () => { console.log("clicked linkedin option"); },
  },
  {
    icon: EmailIcon,
    url: "mailto:valvic6@gmail.com",
    onClick: () => { console.log("clicked email option"); },
  }
];

export const MENU_ITEMS_PROPS = [
  {
    label: 'SHOWCASE',
    onClick: () => { console.log("clicked showcase option"); },
  },
  {
    label: 'ABOUT ME',
    onClick: () => { console.log("clicked about me option"); },
  },
  {
    label: 'CONTACT',
    onClick: () => { console.log("clicked contact option"); },
  }
];
